<template>
  <div class="l-content-inner">
    <div class="c-head">
      <h1 class="head-title">내정보</h1>
      <BreadCrumb :breadcrumbs="getBreadcrumbItems" />
    </div>

    <div class="l-content">
      <!-- D: 내정보(회원정보관리) 페이지 -->
      <div class="p-mypage-info-wrap">
        <div class="l-white-box">
          <!-- D: 상단 탭 : 회원정보관리, 배송지관리, 조색기관리, 문의내역 -->
          <UtilityTabMenu :tab-index="data.tab1Index" />
          <!-- D: c-tab-panel과 c-tab-panel-wrap은 세트임 -->
          <div class="c-tab-panel-wrap type-non-border">
            <!-- tab content: tab1 -->
            <div class="tab-panel" role="tabpanel" aria-labelledby="tab6-4">
              <MileageUserTab />
            </div>
          </div>
          <!-- // D: 상단 탭 : 회원정보관리, 배송지관리, 조색기관리, 문의내역 -->
        </div>
      </div>
    </div>

    <QuickMenu />
  </div>

  <!-- D: POPUP - Wrap밖으로 호출 필요 -->
  <AlimPop v-if="data.popup.isModalVisible" />
  <ZipFindPop v-if="data.popup.isModalVisible2" />
</template>

<script setup name="mileageUser">
import { onMounted, reactive, watch, computed } from "vue";

import QuickMenu from "@/components/paintpro/quickMenu/quickMenu.vue";
import BreadCrumb from "@/components/paintpro/base/breadCrumb.vue";
import UtilityTabMenu from "@/components/paintpro/utility/utilityTabMenu.vue";
import MileageUserTab from "@/components/paintpro/utility/mileageUserTab.vue";
import AlimPop from "@/components/paintpro/utility/alimPop.vue";
import ZipFindPop from "@/components/paintpro/utility/zipFindPop.vue";

import { useRoute } from "vue-router";
import * as store from "@/store";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    token: "",
    isLogin: false,
    basketCount: 0,
    userLoginInfo: {},
    breadcrumbItems: [
      { name: "내정보", path: "/paintpro/utility" },
      { name: "마일리지관리", path: "/" },
    ],
    query: {},
  },
  codes: {
    code01: [],
    code02: [],
  },
  popup: {
    isModalVisible: false,
    isModalVisible2: false,
  },
  tab1Index: 4,
});

watch(
  () => store.useBasketCountStore().basketCount,
  (newValue) => {
    data.page.basketCount = newValue;
  }
);

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  data.page.query = useRoute().query || {};
  await pageInitData();
}

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];
  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} :: [호출: inquireList.pageInitData] `);
    return false;
  }
  data.page.token = cmUtil.getLocalStorage("token");
  data.page.isLogin = store.useAuthStore()?.user ? true : false;
}

const getBreadcrumbItems = computed(() => {
  let list = [
    { name: "내정보", path: "/paintpro/utility" },
    { name: "마일리지내역", path: "" },
  ];
  return list;
});
</script>
<style scoped></style>
